// agriflow/products/static/js/statistics/ProductStatistics.js

import FetchHandler from "../../../../assets/js/assets/FetchHandler";

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export const productsStatistics = async (id) => {
    const accessToken = getCookie('drfToken');
    if (!accessToken) return;
    
    const options = {
        'Content-Type': 'application/json',
        'Authorization': `Token ${accessToken}`,
    };

    try {
        const response = await FetchHandler.getData(`/api/products/detail/${id}/products-statistics/`, options);
        const data = await response.json();
        if (data && response.status === 200) {
            // change start
            document.querySelector('.list-group').innerHTML = `
                <li class="list-group-item flex-fill">Gesamtmenge: ${data.total_quantity}</li>
                <li class="list-group-item flex-fill">Lagerplätze: ${data.locations_count}</li>
            `;
            // change end
        }
    } catch (error) {
        console.error('Fehler:', error);
    }
}